import { ORDER_MOVING_PACKAGES } from '../../namespace/moving/order-moving-packages'
import { API } from '../../../../api/api'
import { saveOrderState } from '../../../helpers/order-state'

export const orderMovingPackages = {
  state: {
    activeId: null,
    price: 0,
    list: []
  },
  mutations: {
    [ORDER_MOVING_PACKAGES.MUTATIONS.SET_ACTIVE_ID](state, id) {
      state.activeId = id
      const activeItem = state.list.find(item => item.id === id)
      if (activeItem && 'make_it_move' in activeItem.prices) {
        state.price = activeItem.prices.make_it_move
      }
      try {
        saveOrderState()
      } catch (e) {
        console.warn('Save order state error', e)
      }
    },
    [ORDER_MOVING_PACKAGES.MUTATIONS.SET_LIST](state, list) {
      state.list = list
    }
  },
  actions: {
    async [ORDER_MOVING_PACKAGES.ACTIONS.GET_LIST]({ commit }) {
      try {
        const response = (await API.getMovingPackages()).data
        commit(ORDER_MOVING_PACKAGES.MUTATIONS.SET_LIST, response)
        return response
      } catch (e) {
        throw new Error('order moving packages request error')
      }
    }
  },
  getters: {
    [ORDER_MOVING_PACKAGES.GETTERS.MOVE_PRICE](state) {
      return state.price
    },
    [ORDER_MOVING_PACKAGES.GETTERS.LIST](state) {
      return state.list
    },
    [ORDER_MOVING_PACKAGES.GETTERS.ACTIVE_ID](state) {
      return state.activeId
    },
    [ORDER_MOVING_PACKAGES.GETTERS.ACTIVE_ITEM](state) {
      if (state.activeId) {
        return state.list.find(item => item.id === state.activeId)
      } else {
        return null
      }
    }
  }
}
